module.exports = __webpack_public_path__ + "media/images/page/top/mv-a65b8db5f783f16af4871ac5d5bd3408.jpg";